import React, {Fragment, useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom'
import {agregarEditarCliente, mostrarClienteById} from '../../redux/reducers/clientesReducer';
import {geoString} from '../../helpers';
import {
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    FormControl,
    Grid,
    IconButton,
    Input,
    InputAdornment,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Theme,
    Typography
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import {SelectEnum, SelectFiles, SelectPais, SelectRuta} from "../../components/selects"
import {AppBar, HtmlTooltip, LoadingProgress, MostrarError, ReferenciasCliente} from "../../components";
import {DateInput, TextFieldCurrency, TextFieldPhone} from "../../components/CustomTextField";
import Strings from "../../assets/strings";
import AddAdjuntos from "../../components/AddAdjuntos";
import {useCustomFormInput} from "../../hooks/useCustomFormInput";
import MapSearch from "../../components/MapSearch";
import SelectUsoMultiples from "../../components/selects/SelectUsoMultiples";
import {IArchivo, ICliente} from "../../redux/types/ICliente";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {ConfCamposType} from "../../redux/types/ICompania";
import _ from "lodash";
import {Close, Save, SearchOutlined} from "@mui/icons-material";
import {consultarPadron} from "../../services";
import Notifications from "react-notification-system-redux";
import {getTokenInfo} from "../../services/auth";
import {TransZoom} from '../../components/transitions';
import SuccessMsj from "../../components/transitions/success";

const useStyles = makeStyles((theme:Theme) => ({
    root:{
     //   padding:"20px",

    },
    paperDialog:{
        width:350
        //   padding:"20px",

    },
    avatar:{
        "& img":{
            maxWidth: 150
        },
        [theme.breakpoints.down('md')]: {
            "& img":{
                borderRadius: "50%",
            }
        }

    },
    submitBtn:{
        margin: 20,
    },
}));

const {PaisId} = getTokenInfo() as any;

let saveAndCreate = false;
let initialState:ICliente = {
    id: undefined,
    tipo: 1,
    razonSocial:"",
    nombres: "",
    apellidos: "",
    cedula: "",
    paisIdNacionalidad: PaisId??undefined,
    email: "",
    estadoCivilId: undefined,
    sexo: "",
    fechaNacimiento: "",
    celular: "",
    telefono: "",
    limiteCredito: undefined,
    avatar: "",
    tipoVivienda: undefined,
    direccion: "",
    coordenadas:"",
    direccion2: "",
    condicionLaboral: undefined,
    trabajoNombre: "",
    trabajoDireccion: "",
    trabajoTelefono: "",
    trabajoPosicion: "",
    trabajoIntervaloCobro: undefined,
    diasCobro: "",
    ingresos: 0,
    tiempoLaborando: "",
    archivos:[],
    //----------
    codigoPostal: "",
    referencias: [],
    dependientes: 0,
    ruta: "",
    rutaId: undefined,

    faceBook:"",
    instagram:"",
}
export default function CrearCliente(){
    const classes = useStyles();
    let { cliId:urlCliId} = useParams()
    let dispatch = useAppDispatch();
    const navigate = useNavigate();
    let {byId:cliente,error, status} = useAppSelector(state => state.clientes);

    const customFormInput = useCustomFormInput() as ConfCamposType;

    const [state, setState] = useState(initialState);

    useEffect(()=>{
        if(urlCliId) dispatch(mostrarClienteById(parseInt(urlCliId)));
    },[urlCliId,dispatch])

    useEffect(()=>{
        if(!!urlCliId && !!cliente?.id && cliente?.id === parseInt(urlCliId)) {
            setState({...initialState,..._.omitBy(cliente, (v) => _.isNil(v))});
        }else{
            setState(initialState)
        }
    },[urlCliId,cliente])
    const handleChange = (e:React.ChangeEvent<HTMLInputElement>)=>{
        const {name,value} = e.target
        return setState({...state,[name]: value});
    }
    const submit = (e:React.FormEvent<HTMLFormElement>) =>{
        e.preventDefault();

        let obj = {...state}

        if(obj.avatar === cliente?.avatar ) {
            obj.avatar = "";
        }

        obj.archivos = obj.archivos?.filter(item => item.base64 !== "-1")


        dispatch(agregarEditarCliente({cliente: obj, crearPrestamo:saveAndCreate,  })).then(({meta, payload})=>{
            if(meta.requestStatus === "fulfilled"){
                setState((payload as any).data);
                setGuardado(true)
            }
        });
    }

    let tipo = state.tipo;


    // const [openMenu, setOpenMenu] = useState<null | HTMLElement>(null);
    const [guardado, setGuardado] = useState(false);
    // const btnSubmit = useRef<HTMLInputElement>(null)


    const [buscandoID, setBuscandoID] = useState(false);
    const verificarCedula = () => {
        if(state.cedula) {
            setBuscandoID(true)
            consultarPadron(state.cedula).then((res) => {
                if(res.status === 204){
                    return dispatch(Notifications.warning({title: Strings.noSeEncontraron+" datos.", autoDismiss: 5}))
                }
                setState(prevState => ({...prevState,
                    nombres: res.data.name??"",
                    apellidos: res.data.lastName??"",
                    sexo: res.data.gender??"",
                    fechaNacimiento: res.data.birthdate??"",
                }))
            }).finally(()=>setBuscandoID(false))
        }
    }

    const {PaisId} = getTokenInfo() as any;
    return(
        <Fragment>
            <AppBar title={state.id ? Strings.editar+" "+Strings.prestatario : Strings.crear+" "+Strings.prestatario } />
            <div className={"contentInner " + classes.root}>
                <MostrarError errors={error}/>
                {(status === "loading") && <LoadingProgress vh/>}


                <form onSubmit={submit} id={"formCliente"} autoComplete={"off"}>
                    <div className={"customCard"}>
                        <Typography color={"primary"} className={"title"}>DATOS GENERALES</Typography>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={2}>
                                <div className={classes.avatar}>
                                    <SelectFiles showImg src={state.avatar ? state.avatar : ""}  emp={tipo === 2}
                                                 onChange={(baseb4:string)=>setState({ ...state, avatar: baseb4 } )}/>
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={10}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={4} md={3}>
                                        <SelectEnum value={tipo} name={"tipo"} label={Strings.tipo} required
                                                    onChange={handleChange} group={"tiposCliente"} />
                                    </Grid>
                                    <Grid item xs={6} sm={4} md={3}>
                                        <TextField
                                            name="cedula"
                                            label={geoString(tipo === 2 ? "rnc":"cedula",false)}
                                            placeholder={tipo === 2 ? geoString("rnc",false):""}
                                            value={state.cedula}
                                            onChange={handleChange}
                                            inputProps={{maxLength: 20}}
                                            fullWidth
                                            required
                                            disabled={buscandoID}
                                            InputProps={PaisId === "7" && tipo === 1 && (state.cedula?.length ?? 0)> 3 ? {
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <HtmlTooltip title={"Validar número de cédula."}>
                                                            <IconButton disabled={buscandoID} color={"primary"} onClick={verificarCedula} size="large">
                                                                {buscandoID?<CircularProgress size={20} color="inherit"/>:<SearchOutlined/>}

                                                            </IconButton>
                                                        </HtmlTooltip>
                                                    </InputAdornment>
                                                ),
                                            }:{}}
                                        />
                                    </Grid>
                                    {tipo === 2 &&
                                    <Grid item xs={12} sm={4} md={3}>
                                        <TextField
                                            name={"razonSocial"}
                                            label={Strings.razonSocial}
                                            value={state.razonSocial}
                                            onChange={handleChange}
                                            inputProps={{maxLength: 50}}
                                            required
                                            fullWidth
                                        />
                                    </Grid>}
                                    <Grid item xs={12} sm={4} md={3}>
                                        <TextField
                                            name={"nombres"}
                                            label={Strings.primerNombre}
                                            placeholder={tipo === 2 ? Strings.representante:""}
                                            value={state.nombres}
                                            onChange={handleChange}
                                            inputProps={{maxLength: 50}}
                                            required
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={3}>
                                        <TextField
                                            name="apellidos"
                                            label={Strings.apellidos}
                                            placeholder={tipo === 2 ? Strings.representante:""}
                                            value={state.apellidos}
                                            onChange={handleChange}
                                            inputProps={{maxLength: 50}}
                                            required
                                            fullWidth
                                        />
                                    </Grid>

                                    {tipo !== 2 &&
                                        <Grid item xs={6} sm={4} md={3}>
                                            <FormControl fullWidth >
                                                <InputLabel>{Strings.genero}</InputLabel>
                                                <Select
                                                    value={state.sexo}
                                                    onChange={({target})=>setState({...state,sexo: target.value})}
                                                    input={<Input name="sexo" />}
                                                >
                                                    <MenuItem value="">{Strings.seleccione}</MenuItem>
                                                    <MenuItem value="M">{Strings.masculino}</MenuItem>
                                                    <MenuItem value="F">{Strings.femenino}</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    }
                                    <Grid item xs={12} sm={4} md={3}>
                                        <TextFieldPhone
                                            flag
                                            name="celular"
                                            label={Strings.celular}
                                            value={state.celular}
                                            onChange={handleChange}
                                            inputProps={{maxLength: 20}}
                                            required={!state.telefono}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={3}>
                                        <TextFieldPhone
                                            flag
                                            name="telefono"
                                            label={Strings.telefono}
                                            value={state.telefono}
                                            onChange={handleChange}
                                            required={!state.celular}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={3}>
                                        <SelectPais
                                            name="paisIdNacionalidad"
                                            display="nacionalidad"
                                            label={Strings.nacionalidad}
                                            value={state.paisIdNacionalidad}
                                            onChange={handleChange}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <br/>
                        <Grid container spacing={3}>
                            {tipo !== 2 && <>
                                <Grid item xs={6} sm={3} md={3} lg={2}>
                                    <SelectEnum value={state.tipoVivienda} name={"tipoVivienda"} label={Strings.vivienda}
                                                onChange={handleChange} group={"tiposVivienda"} />
                                </Grid>
                                <Grid item xs={6} sm={3} md={4} lg={2}>
                                    <SelectEnum value={state.condicionLaboral} name={"condicionLaboral"} label={Strings.condicionesLaboral}
                                                onChange={handleChange} group={"condicionesLaboral"} />
                                </Grid>
                                <Grid item xs={6} sm={3} md={3} lg={2}>
                                    <TextFieldCurrency
                                        name="ingresos"
                                        label={Strings.ingreso}
                                        value={state.ingresos}
                                        onChange={handleChange}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={6} sm={3} md={2}>
                                    <SelectEnum value={state.estadoCivilId} name={"estadoCivilId"} label={Strings.estadoCivil}
                                                onChange={handleChange} group={"estadosCivil"} />
                                </Grid>
                                <Grid item xs={6} sm={3} md={2}>
                                    <TextField

                                        name="dependientes"
                                        label={Strings.dependientes}
                                        value={state.dependientes}
                                        type="number"
                                        inputProps={{step:1,inputMode:"numeric"}}
                                        onChange={handleChange}
                                        fullWidth
                                    />
                                </Grid>
                            </>}
                            <Grid item xs={6} sm={3} md={2}>
                                <TextField

                                    name="limiteCredito"
                                    label={Strings.limiteCredito}
                                    value={state.limiteCredito??""}
                                    type="number"
                                    inputProps={{step:1,inputMode:"numeric"}}
                                    onChange={handleChange}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={tipo === 2?6:8} lg={5}>
                                <MapSearch handleChange={(obj:{coordenadas:string})=>setState({...state,...obj})}
                                           direccion={state.direccion??""} coordenadas={state.coordenadas}/>
                            </Grid>

                            <Grid item xs={12}  sm={tipo === 2?6:5} md={tipo === 2?4:5} lg={5}>
                                <TextField
                                    name="direccion2"
                                    label={Strings.direccion + " 2"}
                                    value={state.direccion2}
                                    placeholder={Strings.referenciaDireccion}
                                    onChange={handleChange}
                                    inputProps={{maxLength: 100}}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={6} sm={3} lg={2}>
                                <TextField
                                    name="codigoPostal"
                                    label={Strings.codigoPostal}
                                    value={state.codigoPostal}
                                    onChange={handleChange}
                                    inputProps={{maxLength: 20}}
                                    fullWidth
                                />
                            </Grid>
                            {tipo !== 2 &&
                                <Grid item xs={12} sm={4} lg={3}>
                                    <DateInput
                                        openTo={"year"}
                                        clearable
                                        value={state.fechaNacimiento}
                                        name="fechaNacimiento"
                                        label={Strings.fechaNacimiento}
                                        onChange={handleChange}
                                        fullWidth native={undefined} views={undefined} quincenalFijo={undefined}
                                    />
                                </Grid>}
                            {/*<Grid item xs={6} sm={4} md={4} lg={2}>*/}
                            {/*    <TextField*/}
                            {/*        name="faceBook"*/}
                            {/*        label="FaceBook"*/}
                            {/*        value={state.faceBook}*/}
                            {/*        onChange={handleChange}*/}
                            {/*        inputProps={{maxLength: 50}}*/}
                            {/*        fullWidth*/}
                            {/*    />*/}
                            {/*</Grid>*/}
                            {/*<Grid item xs={6} sm={4} md={4} lg={2}>*/}
                            {/*    <TextField*/}
                            {/*        name="instagram"*/}
                            {/*        label="Instagram"*/}
                            {/*        value={state.instagram}*/}
                            {/*        onChange={handleChange}*/}
                            {/*        inputProps={{maxLength: 50}}*/}
                            {/*        fullWidth*/}
                            {/*    />*/}
                            {/*</Grid>*/}
                            <Grid item xs={6} sm={4} lg={2}>
                                <TextField
                                    name="email"
                                    type={"email"}
                                    label="Email"
                                    value={state.email}
                                    onChange={handleChange}
                                    inputProps={{maxLength: 50}}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sm={8} md={4} lg={3}>
                                <SelectRuta value={state.rutaId}
                                            name={"rutaId"}
                                            label={Strings.ruta}
                                            onChange={handleChange}  />
                            </Grid>


                            {customFormInput && Object.keys(customFormInput).map((key)=>
                                <Grid item xs={12} sm={4} lg={2} key={key}>

                                    {!!(customFormInput)[key].source?(
                                        <SelectUsoMultiples
                                            emptyOption={{key:0,value:Strings.ninguna}}
                                            group={customFormInput[key].source ?? ""}
                                            name={"campo"+key.slice(-1)}
                                            label={customFormInput[key].name ?? ""}
                                            required={customFormInput[key].isRequired}
                                            value={(state as any)["campo"+key.slice(-1)] ? (state as any)["campo"+key.slice(-1)] : undefined}
                                            onChange={handleChange}
                                            // inputProps={{maxLength: 50}}
                                        />

                                    ):(
                                        <TextField
                                            name={"campo"+key.slice(-1)}
                                            label={customFormInput[key].name}
                                            required={customFormInput[key].isRequired}
                                            value={(state as any)["campo"+key.slice(-1)] ? (state as any)["campo"+key.slice(-1)] : ""}
                                            onChange={handleChange}
                                            inputProps={{maxLength: 50}}
                                            fullWidth
                                        />
                                    )}

                                </Grid>
                            )}
                        </Grid>
                    </div>

                    {state.condicionLaboral === 1 && tipo !== 2 &&
                        <div className={"customCard"}>
                            <Typography color={"primary"} className={"title"}>{Strings.empresa}</Typography>
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={4} md={3}>
                                    <TextField
                                        name="trabajoNombre"
                                        label={Strings.empresa}
                                        value={state.trabajoNombre}
                                        onChange={handleChange}
                                        inputProps={{maxLength: 50}}
                                        fullWidth
                                        required
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4} md={3}>
                                    <SelectEnum value={state.trabajoIntervaloCobro} name={"trabajoIntervaloCobro"}
                                                label={Strings.intervaloCobro} onChange={handleChange} group={"ciclosPago"} />
                                </Grid>
                                <Grid item xs={12} sm={4} md={3}>
                                    <TextField
                                        name="diasCobro"
                                        label={Strings.diasCobro}
                                        value={state.diasCobro}
                                        onChange={handleChange}
                                        inputProps={{maxLength: 50}}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4} md={3}>
                                    <TextField
                                        name="trabajoPosicion"
                                        label={Strings.posicion}
                                        value={state.trabajoPosicion}
                                        onChange={handleChange}
                                        inputProps={{maxLength: 50}}
                                        fullWidth
                                        required
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4} md={3}>
                                    <TextField
                                        name="tiempoLaborando"
                                        label={Strings.tiempoLaborando}
                                        value={state.tiempoLaborando}
                                        inputProps={{maxLength: 50}}
                                        onChange={handleChange}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4} md={3}>
                                    <TextFieldPhone
                                        name="trabajoTelefono"
                                        label={Strings.telefono}
                                        value={state.trabajoTelefono}
                                        onChange={handleChange}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        name="trabajoDireccion"
                                        label={Strings.direccion}
                                        value={state.trabajoDireccion}
                                        onChange={handleChange}
                                        inputProps={{maxLength: 100}}
                                        fullWidth
                                    />
                                </Grid>
                            </Grid>
                        </div>
                    }

                    <br/>
                        <AddAdjuntos adjuntos={state.archivos} onChange={(archivos:IArchivo[])=>setState({...state,archivos})} />

                    <ReferenciasCliente referencias={state.referencias}
                                        onChange={(referencias)=>setState({...state,referencias})} />

                    {/*<input type={"submit"}  ref={btnSubmit} style={{display:"none"}}/>*/}

                </form>
                <Box className={"formControl"}>
                    <Button sx={{mr:0.5}} color={"error"} onClick={()=>navigate(-1)} variant={"outlined"} disabled={status==="loading"} startIcon={<Close/>} size={"small"}>{Strings.cancelar}</Button>


                    {/*{state.id ? (*/}
                            <Button type={"submit"} form={"formCliente"} size={"small"} variant={"outlined"} disabled={status==="loading"}  startIcon={<Save/>} >
                                {status === "loading"? (
                                    <span><CircularProgress size={14} color="inherit" /> &nbsp; {Strings.cargando}</span>
                                ):(
                                    <span>{state.id? Strings.actualizar: Strings.guardar} </span>
                                )}
                            </Button>
                    {/*    ):(*/}
                    {/*    <>*/}
                    {/*        <ButtonGroup variant="outlined">*/}
                    {/*            <Button type={"button"}  onClick={()=>{saveAndCreate=true; btnSubmit.current?.click()}} size={"small"} variant={"outlined"} disabled={status==="loading"}  startIcon={<Save/>} >*/}
                    {/*                {status === "loading"? (*/}
                    {/*                    <span><CircularProgress size={14} color="inherit" /> &nbsp; {Strings.cargando}</span>*/}
                    {/*                ):(*/}
                    {/*                    <span>{Strings.guardar} {Strings.y} {Strings.crear} {Strings.prestamo} </span>*/}
                    {/*                )}*/}
                    {/*            </Button>*/}
                    {/*            <Button*/}
                    {/*                size="small"*/}
                    {/*                aria-haspopup="menu"*/}
                    {/*                onClick={(e)=>setOpenMenu(e.currentTarget)}*/}
                    {/*                sx={{width: "35px"}}*/}
                    {/*            >*/}
                    {/*                <ArrowDropDown />*/}
                    {/*            </Button>*/}
                    {/*        </ButtonGroup>*/}
                    {/*        <Menu id="long-menu" anchorEl={openMenu} keepMounted open={Boolean(openMenu)} onClose={()=>setOpenMenu(null)}*/}
                    {/*              anchorOrigin={{*/}
                    {/*                  vertical: 'top',*/}
                    {/*                  horizontal: 'left',*/}
                    {/*              }}*/}
                    {/*              transformOrigin={{*/}
                    {/*                  vertical: 'top',*/}
                    {/*                  horizontal: 'left',*/}
                    {/*              }}*/}
                    {/*        >*/}
                    {/*            <MenuItem>*/}
                    {/*                <ListItemIcon>*/}
                    {/*                    <Save fontSize="small" />*/}
                    {/*                </ListItemIcon>*/}
                    {/*                <ListItemText onClick={()=>{saveAndCreate=false; btnSubmit.current?.click();}}>*/}
                    {/*                    {Strings.guardar} {Strings.y} {Strings.crear} {Strings.nuevo}*/}
                    {/*                </ListItemText>*/}
                    {/*            </MenuItem>*/}
                    {/*        </Menu>*/}
                    {/*    </>*/}
                    {/*)}*/}



                </Box>
            </div>


            <Dialog //Boolean(data?.cliId > 0)
                TransitionComponent={TransZoom}
                maxWidth={"xs"}
                open={guardado}
                // maxWidth={reciboSize===8.5?"lg":"xs"}
                fullWidth={true}
                onClose={()=>setGuardado(false)}
                classes={{paper:classes.paperDialog}}
            >
                <IconButton
                    size={"small"}
                    onClick={()=>setGuardado(false)}
                    style={{
                        position: "absolute",
                        top: 2,
                        right: 2
                    }}
                >
                    <Close/>
                </IconButton>
                <DialogContent>
                    <br/>
                    {SuccessMsj()}

                    <Typography textAlign={"center"} variant={"h5"} color={"#4caf50"} marginTop={1}>Cliente guardado con exito.</Typography>

                    <Typography textAlign={"center"}  marginTop={1}>¿Que deseas hacer ahora?</Typography>

<br/>
                </DialogContent>
                <DialogActions sx={{ borderTop: "1px solid #d2d2d2", justifyContent:"center"}}>
                    <Button
                        onClick={()=> {
                            setGuardado(false)
                            setState(initialState)
                        }}

                        style={{background:"#e8e8e8"}} >
                        Agregar nuevo
                    </Button>
                    <Button
                        onClick={()=> {
                            setGuardado(false)
                            navigate('/crear/prestamo', {
                                state: {
                                    cliente: {
                                        clienteId: state.id,
                                        fullName: state.nombres + " " + state.apellidos
                                    }
                                }
                            })
                        }}
                        variant={"contained"}  disableElevation>
                        Crear préstamo
                    </Button>

                </DialogActions>
            </Dialog>
        </Fragment>
    );

}
